export function addSlottedStyles(hostElement: HTMLElement, styleSheet: string) {
  const componentTag = hostElement.tagName.toLowerCase();
  const styleElementId = `${componentTag}-style`;

  if (document.getElementById(styleElementId)) {
    return;
  }

  const styleElement = document.createElement('style');
  styleElement.id = styleElementId;
  styleElement.innerHTML = styleSheet.replace(/\[/g, `${componentTag} [`);
  document.head.appendChild(styleElement);
}

export function setAttributesToSlottedElement({
  hostElement,
  slotName,
  slottedElementTag,
  attributes,
}: {
  hostElement: HTMLElement;
  slotName?: string;
  slottedElementTag: string;
  attributes: { name: string; value: string }[];
}) {
  let slotElement: HTMLSlotElement;
  if (slotName) {
    slotElement = hostElement.shadowRoot.querySelector(`[name="${slotName}"]`);
  } else {
    slotElement = hostElement.shadowRoot.querySelector('slot');
  }
  if (slotElement) {
    slotElement.removeEventListener('slotchange', handleSlotChange);
    slotElement.addEventListener('slotchange', handleSlotChange);
  }

  function handleSlotChange() {
    const assignedNodes = slotElement.assignedNodes({ flatten: true });
    if (!assignedNodes || assignedNodes.length < 1) return;
    const targetElement = assignedNodes.find(node => {
      return node.nodeName.toLowerCase() === slottedElementTag;
    });
    if (!targetElement) return;
    attributes.forEach(attribute => {
      (targetElement as HTMLElement).setAttribute(attribute.name, attribute.value);
    });
  }
}
